import { deleteCell, resetCell } from './styles';

export const getColumns = (
  openSN: (value: number) => void,
  openReset: (value: string) => void,
  t: (value: string) => string,
) => [
  {
    field: 'priority',
    headerName: '',
    width: 30,
    editable: true,
    align: 'center' as any,
  },
  {
    field: 'reset',
    headerName: t('common.reset'),
    width: 70,
    renderCell: resetCell(openReset),
  },
  {
    field: 'serialNumber',
    headerName: t('settings.serialNumber'),
    width: 170,
  },
  {
    field: 'sku',
    headerName: t('settings.sku'),
    width: 94,
    align: 'center' as any,
  },
  {
    field: 'customerName',
    headerName: t('common.companyName'),
    flex: 1,
  },
  {
    field: 'shippingPoint',
    headerName: t('common.shippingPoint'),
    width: 120,
    align: 'right' as any,
  },
  {
    field: 'delete',
    headerName: t('buttons.delete'),
    width: 71,
    renderCell: deleteCell(openSN),
  },
];
